import React, { Component } from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import s from './VerificationSuccess.css';
import cs from '../../components/commonStyle.css';
import { Modal, Button } from 'react-bootstrap';
import { injectIntl } from 'react-intl'; 
import { connect } from 'react-redux';
import messages from '../../locale/messages';
import success_check from '../../../public/siteImages/successCheck.png';

class VerificationSuccess extends Component {
    static propTypes = {
        onClose: PropTypes.func.isRequired,
        show: PropTypes.bool.isRequired,
        emailOrPhone: PropTypes.string,
    };

    render() {
        const { onClose, show, emailOrPhone } = this.props;
        const { formatMessage } = this.props.intl;
console.log(emailOrPhone,"emailOrPhone");
        // Determine the message and heading based on whether emailOrPhone is provided
        let heading;
        let message;
        if (emailOrPhone) {
            if (emailOrPhone.includes('@')) {
                heading = formatMessage(messages.verificationSuccessEmailHeading);
                message = formatMessage(messages.verificationSuccessEmailMessage, { email: emailOrPhone });
            } else {
                heading = formatMessage(messages.verificationSuccessSMSHeading);
                message = formatMessage(messages.verificationSuccessSMSMessage, { phone: emailOrPhone });
            }
        } else {
            heading = formatMessage(messages.verificationSuccessEmailHeading);
            message = formatMessage(messages.verificationSuccessGenericMessage);
        }

        return (
            <Modal show={show} animation={false} onHide={onClose} className="verificationModal">
                <div className={cx(s.sectionBlock)}>
                    <Modal.Header closeButton></Modal.Header>
                    <Modal.Body>
                        <div className={cx(s.verificationContent, cs.textAlignCenter)}>
                            <img src={success_check} alt="Verification Success" className={s.verificationImage} />
                            <h2 className={cx(s.titleText)}>{heading}</h2>
                            <p className={cx(s.contentText)}>{message}</p>
                            <Button  className={cx(cs.btnPrimary, cs.fullWidth, cs.commonMediumText)} onClick={onClose}>
                                {formatMessage(messages.verificationSuccessOkay)}
                            </Button>
                        </div>
                    </Modal.Body>
                </div>
            </Modal>
        );
    }
}

const mapState = state => ({});

const mapDispatch = {};

export default injectIntl(withStyles(s, cs)(connect(mapState, mapDispatch)(VerificationSuccess))); 